import api from '@/api/api';
import { ApiFacility } from '.';
import { IFacility } from '@/models/facility';
import getApiResponse from '@/api/apiResponse';

const FacilityService = {
  getHospitalList: async () => {
    const res = await api.get(ApiFacility.GET_HOSPITAL_LIST);
    return getApiResponse<Array<IFacility>>(res);
  },

  getFacility: async (facilityKey: number) => {
    const params = { facilityKey };
    const res = await api.get(ApiFacility.GET_FACILITY, { params });
    return getApiResponse<IFacility>(res);
  },
};

export default FacilityService;
